import { render, staticRenderFns } from "./SideBare.vue?vue&type=template&id=d2b5d8f2&scoped=true"
import script from "./SideBare.vue?vue&type=script&lang=js"
export * from "./SideBare.vue?vue&type=script&lang=js"
import style0 from "./SideBare.vue?vue&type=style&index=0&id=d2b5d8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b5d8f2",
  null
  
)

export default component.exports